import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import { Container } from '~/styles/pagesStyle';
import { handleRegisterModulo } from '../ModulosServices';
import ModuloCard from './ModuloCard';

const initialForm = {
  cor: '#000',
  classe: '   ',
};

function ModuloCadastro() {
  const history = useHistory();
  const usuario = sessionStorage.getItem('@auth/userName');
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(initialForm);
  const [ordem, setOrdem] = useState(0);

  async function handleSubmit(e) {
    if (!form.nome) {
      toast.error('Nome do módulo é obrigatório');
      return;
    }
    if (!form.situacaoCadastral) {
      toast.error('Situação cadastral é obrigatório');
      return;
    }
    if (!form.ordem) {
      toast.error('Ordem é obrigatório');
      return;
    }
    setLoading(true);
    e.preventDefault();
    const modulo = {
      id: 0,
      nome: form.nome,
      idsituacaoCadastral: form.situacaoCadastral,
      cor: form.cor,
      classeCss: form.classe,
      ordem: form.ordem,
      dataInclusao: null,
      usuario,
      excluido: false,
    };
    await handleRegisterModulo(modulo, setLoading, history);
  }

  return (
    <Container>
      <Footer />
      <Menu />
      <ModuloCard
        handleSubmit={handleSubmit}
        setForm={setForm}
        form={form}
        setOrdem={setOrdem}
        ordem={ordem}
        loading={loading}
      />
    </Container>
  );
}

export default ModuloCadastro;
